import type { FilterOption } from '@/components/FilterMenu'
import { FilterMenu } from '@/components/FilterMenu'
import { useTranslation } from 'react-i18next'

interface ApprovalStateFilterProps {
  options: FilterOption[]
  selectedOption: FilterOption | null
  onChange: (option: FilterOption | null) => void
}

export function ApprovalStateFilter({
  options,
  selectedOption,
  onChange,
}: ApprovalStateFilterProps) {
  const { t } = useTranslation()

  return (
    <FilterMenu
      buttonLabel={t('clusterConfigTable.filters.approvalState')}
      options={options}
      selectedOption={selectedOption}
      onOptionChange={onChange}
      isSearchable
      data-testid="approval-state-filter"
    />
  )
}
